import React from 'react'
import "./AddNewProductHeadingSection.css"
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';

const AddNewProductHeadingSection = ({redirected}) => {
  const editProduct = useSelector(state => state.products.editProduct);
  return (
    <div className="addNewHeadingSection">
        <Link to={redirected ? "/create-campaign" : "/products"} className="addNew-leftSection">
            <img src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/back.svg" alt="back-icon" />
        </Link>
        <div className="addNew-rightSection">
            <h2 className='addNewHeading'>{editProduct ? "Update Product" : "Add new Product"}</h2>
            <p className="addNewNote">{editProduct ? "Please enter these details and update this product" : "Please enter these details and add this product"}</p>
        </div>
    </div>
  )
}

export default AddNewProductHeadingSection